import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  styled,
} from '@mui/material';
import StyledButton from '../../../Button';

export const StyledDialog = styled(Dialog)({
  '.MuiDialog-paper': {
    borderRadius: '8px',
    padding: '32px',
  },
});

export const StyledDialogTitle = styled(DialogTitle)({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center',
  fontFamily: '"Inter", sans-serif',
  fontSize: '32px',
  fontStyle: 'normal',
  fontWeight: 700,
});

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.up('sm')]: {
    minWidth: '400px',
  },
}));

export const StyledDialogContentText = styled(DialogContentText)({});

export const StyledDialogActions = styled(DialogActions)({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
});

export const StyledDialogAction = styled(StyledButton)({
  width: '100%',
});
